import React, { FC } from 'react';
import Svg from 'svg-inline-react';
import classnames from 'classnames';
import qs from 'qs';
import { useHistory } from 'react-router-dom';
import FrLocationSvg from '@src/svgs/fr-location.svg';
import FrBinocularSvg from '@src/svgs/fr-binocular.svg';
import FrApprovedSvg from '@src/svgs/fr-approved.svg';
import { TALENT_ACTIVITY_ROUTE } from '@src/Routes/links';
import { TalentActivityFeedSignalEnum } from '@src/graphql/generated';
import { useQueryParams } from '@src/customHooks/useQueryParams';
import { Positions } from './Positions';
import { QueryParams } from './interfaces/queryParams.interface';
import './styles.scss';

const MAIN_ACTIONS_LIST = [
  { icon: FrLocationSvg, label: 'All', signal: 'ALL', type: 'pink' },
  { icon: FrBinocularSvg, label: 'Views', signal: TalentActivityFeedSignalEnum.VIEW_DETAILS, type: 'blue' },
  { icon: FrApprovedSvg, label: 'Applied', signal: TalentActivityFeedSignalEnum.START_APPLY, type: 'blue' },
];

export const Filters: FC = () => {
  const { queryParams } = useQueryParams<QueryParams>();

  const history = useHistory();

  const selectedPositions = queryParams.positions || [];

  const selectedSignal = queryParams.signal || 'ALL';

  const handlePositionSelect = (positionId: string) => {
    let updatedQueryParams: QueryParams;

    if (selectedPositions.includes(positionId)) {
      updatedQueryParams = {
        ...queryParams,
        positions: selectedPositions.filter(position => position !== positionId),
      };
    } else {
      updatedQueryParams = {
        ...queryParams,
        positions: [...selectedPositions, positionId],
      };
    }

    history.replace(`${TALENT_ACTIVITY_ROUTE}/${qs.stringify(updatedQueryParams, { addQueryPrefix: true })}`);
  };

  const handleSignalSelect = (signal: TalentActivityFeedSignalEnum | 'ALL') => {
    const updatedQueryParams: QueryParams = {
      ...queryParams,
      signal: signal,
    };

    history.replace(`${TALENT_ACTIVITY_ROUTE}/${qs.stringify(updatedQueryParams, { addQueryPrefix: true })}`);
  };

  return (
    <div className="talent-activity-filters">
      <div className="talent-activity-filters__section">
        <div className="talent-activity-filters__title">FILTER BY</div>
        <div className="talent-activity-filters__actions-list">
          {MAIN_ACTIONS_LIST.map((action, index) => {
            const { icon, label, type } = action;

            return (
              <div
                className={classnames(
                  'talent-activity-filters__action-list-item',
                  `talent-activity-filters__action-list-item--${type}`,
                  selectedSignal === action.signal && 'talent-activity-filters__action-list-item--active',
                )}
                key={index}
                onClick={() => handleSignalSelect(action.signal)}
              >
                <Svg src={icon} />
                <span>{label}</span>
              </div>
            );
          })}
        </div>
      </div>

      <div className="talent-activity-filters__section">
        <Positions onPositionSelect={handlePositionSelect} selectedPositions={selectedPositions} />
      </div>
    </div>
  );
};
